<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Plan</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'planId' || editMode" :for="field.name">{{ field.label }}:</label>
              <input v-if="(field.name !== 'active' && field.name !== 'status' && field.name !== 'trial' && field.name !== 'planId' && field.name !== 'application') || (field.name === 'planId' && editMode)"
                  :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                  type="text" class="form-control" :disabled="(field.name === 'planId' || field.name === 'planName') && editMode">
              <select v-else-if="field.name === 'application'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="max-width: 500px;">
                <option v-for="app in applicationList" :key="app" :value="app">{{ app }}</option>
              </select>
              <input class="checkbox" v-else-if="field.name === 'active' || field.name === 'status' || field.name === 'trial'"
                  type="checkbox" :id="field.name" v-model="editedConfig[field.name]">
            </div>
            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Plan' }}</a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {Plan} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'PlanEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        planId : this.$route.params.planId,
        planName : this.$route.params.planName,
        description : this.$route.params.description,
        duration : this.$route.params.duration,
        orderNumber : this.$route.params.orderNumber,
        price  : this.$route.params.price,
        maxDevices : this.$route.params.maxDevices,
        application : this.$route.params.application,
        active: this.$route.params.active,
        status: this.$route.params.status,
        trial: this.$route.params.trial
      },
      editMode: false,
      applicationList: [],
      fields: [
        { name: "planId", label: "Plan Id" },
        { name: "planName", label: "Plan Name" },
        { name: "description", label: "Description" },
        { name: "duration", label: "Duration" },
        { name: "orderNumber", label: "Order number" },
        { name: "price", label: "Price" },
        { name: "maxDevices", label: "Max devices" },
        { name: "application", label: "Application" },
        { name: "active", label: "Active" },
        { name: "status", label: "Status" },
        { name: "trial", label: "Trial" }
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.planId) {
      this.editMode = true;
    }
    const storedApps = localStorage.getItem('applicationList');
    if (storedApps) {
      this.applicationList = JSON.parse(storedApps);
    } else {
      AdminService.getApplications().then(() => {
        this.applicationList = JSON.parse(localStorage.getItem('applicationList'));
      });
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new Plan(
          this.editedConfig.planId ,
          this.editedConfig.planName ,
          this.editedConfig.description ,
          this.editedConfig.duration ,
          this.editedConfig.orderNumber ,
          this.editedConfig.price  ,
          this.editedConfig.maxDevices ,
          this.editedConfig.application ,
          this.editedConfig.active,
          this.editedConfig.status,
          this.editedConfig.trial
      );

      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updatePlan(dataToSave).then(() => {
          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'Plans' });
        })
        .catch((error) => {
          console.error("Error updating Plans:", error);
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertPlan(dataToSave).then(() => {
          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'Plans' });
        })
        .catch((error) => {
          this.error = error.message
        });
      }
    }

  }
})
</script>
<style src="../../assets/style.css">
</style>
